export default __webpack_public_path__ + "static/media/Mal.c5481290.svg";